/**
 * created by tian ruo jun
 表单子项
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Select} from "antd";

const {Option} = Select;

export default class RmtSelect extends Component {
    static defaultProps = {
        type: "select",
        onChange: () => {
        },
        value: "",
    };
    static propTypes = {
        type: PropTypes.string.isRequired,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let {value, disabled, field, onChange, formItemSizeConfig, id, selectvalue} = this.props;
        let optionData = [];
        if(selectvalue&&selectvalue.length) {
            optionData = selectvalue.split('|').map(item=>{
                let arr = item.split(';');
                if(arr&&arr.length) {
                    let key = arr[0];
                    let value = arr[1];
                    if(key&&value){
                        return {key,value}
                    }
                }
            })
        }
        return <Select
            id={id}
            size={formItemSizeConfig.inputSize || 'default'}
            style={{ width: '100%' }}
            placeholder="请选择"
            disabled={disabled}
            value={value?value:[]}
            onChange={(val)=>{
                onChange(field, val)
            }}
        >
            {
                optionData && optionData.length ?
                    optionData.map(item=>{
                        return (
                            <Option key={item.key} value={item.key}>{item.value}</Option>
                        )
                    }) : ""
            }
        </Select>
    }
}